import { apiClient } from "../../../shared/api/client";
import { TRANSACTION_ENDPOINTS } from "./endpoints";
import { toast } from "sonner";
import { getApiErrorMessage } from "../../../shared/lib";

export const downloadTransactionReceipt = async (transactionId: string): Promise<void> => {
  if (!transactionId) {
    toast.error("Transaction ID is required to download receipt");
    return;
  }

  const toastId = toast.loading("Downloading transaction receipt...");
  try {
    const response = await apiClient.get(
      TRANSACTION_ENDPOINTS.RECEIPT(transactionId),
      { responseType: "blob" }
    );

    const contentType = String(response.headers?.["content-type"] || "");
    // If JSON response (e.g. { status: true, data: { url: "..." } })
    if (contentType.includes("application/json")) {
      const text = await (response.data as Blob).text();
      try {
        const json = JSON.parse(text);
        const receiptUrl =
          json?.data?.url ||
          json?.url ||
          json?.data?.receiptUrl ||
          json?.receipt;
        if (receiptUrl) {
          window.open(receiptUrl, "_blank");
          toast.success("Receipt opened successfully", { id: toastId });
          return;
        }
      } catch {
        // Fall back to standard blob download
      }
    }

    const disposition = String(response.headers?.["content-disposition"] || "");
    const filenameMatch = disposition.match(/filename="?([^";]+)"?/i);
    const filename = filenameMatch?.[1] || `Receipt-${transactionId}.pdf`;

    const blob = new Blob([response.data], {
      type: contentType || "application/pdf",
    });
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);

    toast.success("Receipt downloaded successfully", { id: toastId });
  } catch (error) {
    console.error("Failed to download transaction receipt:", error);
    toast.error(
      getApiErrorMessage(error, "Failed to download transaction receipt"),
      { id: toastId }
    );
  }
};

